import {
  ADDED_LAYER,
  GRADIENT_TYPE,
  OBSTACLE_SUBTYPE,
  OBSTACLE_TYPE,
} from "./../ENUM.js";
import * as GAME from "./../GAME.js";
import * as GRADIENT from "./../GRADIENT.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

import { getStripesGradientStopArray } from "./../../utils.js";

export const GARDN = {
  isDark: true,
  startHealth: 60,
  timeAllowedSecs: 50,
  textColor: "#e210fe",
  textColorHighlight: "#ff6666",
  bgColor: "#44aa00",
  bgFadeAlpha: 0.65,
  gameplayAreaToCanvasLateralRatio: 0.66,
  player: {
    color: "#333366",
    growthDivisor: 600,
    //speedCentre: 77,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 90,
      color_ar: ["#49b601"],
      radiusRange: [16, 29],
      directionRange: [179, 181],
      speedRange: [GAME.STATIC_OBSTACLE_SPEED, GAME.STATIC_OBSTACLE_SPEED],
      numAppendagesRange: [3, 4],
      shapeCenterRadiusDivisor: 40,
      shapeCenterColor_ar: ["#49b601"],
    },
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 33,
      color_ar: ["#3c9301"],
      radiusRange: [16, 29],
      directionRange: [179, 181],
      speedRange: [GAME.STATIC_OBSTACLE_SPEED, GAME.STATIC_OBSTACLE_SPEED],
      numAppendagesRange: [3, 4],
      shapeCenterRadiusDivisor: 40,
      shapeCenterColor_ar: ["#3c9301"],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 40,
      color_ar: ["#adb1fd"],
      radiusRange: [30, 40],
      directionRange: [120, 240],
      speedRange: [2, 3],
      numAppendagesRange: [5, 9],
      rotationSpeedRange: [0.05, 0.09],
      shapeCenterRadiusDivisor: 5,
      shapeCenterColor_ar: ["#ffffff"],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 10,
      color_ar: ["#003607"],
      radiusRange: [22, 27],
      directionRange: [120, 240],
      speedRange: [2, 3],
      rotationSpeedRange: [0.05, 0.09],
      addedLayer_ar: [
        {
          type: ADDED_LAYER.STEM,
          color: "#336700",
          // Following sizes are given as a proportion of obstacle radius, 0-1
          thickness: 0.2,
          offsetFront: 1.1,
          offsetRear: 1.3,
          degreeSpanFront: 2,
          degreeSpanRear: 12,
        },
      ],
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 7,
      color_ar: ["#ff0000"],
      radiusRange: [16, 17],
      directionRange: [120, 240],
      speedRange: [2, 3],
      gradient: {
        type: GRADIENT_TYPE.LINEAR,
        stop_ar: getStripesGradientStopArray(["#ffff00", "#000000"], 3),
      },
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 7,
      color_ar: ["#ff0000"],
      radiusRange: [8, 10],
      directionRange: [120, 240],
      speedRange: [1, 2],
      rotationSpeedRange: [2, 2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR,
        stop_ar: getStripesGradientStopArray(["#ff6600", "#000000"], 2),
      },
    },
    {
      type: OBSTACLE_TYPE.FLOATING,
      total: 13,
      color_ar: ["#dddddd"],
      radiusRange: [70, 78],
      directionRange: [120, 240],
      speedRange: [0.01, 0.03],
      gradient: GRADIENT.CLOUD_LIGHT,
    },
    {
      type: OBSTACLE_TYPE.FLOATING,
      total: 13,
      color_ar: ["#dddddd"],
      radiusRange: [96, 99],
      directionRange: [120, 240],
      speedRange: [0.03, 0.09],
      gradient: GRADIENT.CLOUD_MEDIUM,
    },
    {
      type: OBSTACLE_TYPE.FLOATING,
      total: 20,
      color_ar: ["#dddddd"],
      radiusRange: [130, 150],
      directionRange: [120, 240],
      speedRange: [0.2, 0.3],
      gradient: GRADIENT.CLOUD_LIGHT,
    },
  ],
};
